/**
 * InlineTimeRuler Component
 * Extracted from DAWWorkspace.jsx for better modularity
 * Displays time markers on the timeline
 */

export const InlineTimeRuler = ({ duration, zoom }) => {
  const markers = [];
  const interval = duration > 120 ? 30 : duration > 60 ? 10 : 5;
  
  for (let i = 0; i <= duration; i += interval) {
    markers.push(i);
  }
  
  return (
    <div className="relative h-full" style={{ width: `${100 * zoom}%` }}>
      {markers.map((time) => (
        <div
          key={time}
          className="absolute top-0 h-full flex flex-col items-center"
          style={{ left: `${(time / duration) * 100}%` }}
        >
          <div className="h-2 w-px bg-zinc-600" />
          <span className="text-xs text-zinc-500 mt-0.5 font-mono">
            {Math.floor(time / 60)}:{(time % 60).toString().padStart(2, '0')}
          </span>
        </div>
      ))}
    </div>
  );
};

export default InlineTimeRuler;
